/* istanbul ignore file */
import { connect } from 'react-redux';
import FeatureFlagView from './FeatureFlagView';

const mapStateToProps = (state, ownProps) => {
    const { appData } = state.appData;

    return {
        appData,
        store: ownProps.store
    };
}

const mapDispatchToProps = (/*dispatch*/) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFlagView);